import React from 'react';
//connect can also be used with functional components if need be
import { connect } from 'react-redux';

import { setCurrentSlide, setSlideshowSpinnerIsHidden, saveReferenceToPauseMethod, setImageLoaded } from '../../actions';

const PRELOAD_BEHIND = 1;
const PRELOAD_AHEAD = 2;

class SlideShow extends React.Component {
    constructor(props) {
        super(props);
        this.slideInterval = 0;
        this.currentSlide = this.props.currentSlide; //get current slide from store state
        this.playing = true;
        this.initialImageLoaded = false;
        this.change_image_time = 5000;
        //can't do this here because the DOM has not been rendered yet,
        //thats why componentDidMount is the place to look into the DOM.
        //this.pauseButton = document.getElementById('pause');
    };

    // The slideshow becomes ready when its current image loads, rather than waiting for every image.
    // The first slide appears as soon as it is ready, and the autoplay timer starts then.
    // Thumbnail and gallery behavior are unchanged.
    handleSlideImageLoad = (index) => {
        const isCurrentSlide = index === this.props.currentSlide ||
            (this.props.currentSlide === -1 && index === 0);

        if (isCurrentSlide && !this.initialImageLoaded) {
            this.initialImageLoaded = true;
            this.props.setImageLoaded();

            if (this.props.currentSlide === -1) {
                this.currentSlide = 0;
                this.props.setCurrentSlide(0);
                this.hideSlideShowSpinner();
            }

            if (this.playing && !this.slideInterval) {
                this.slideInterval = setInterval(this.nextSlide, this.change_image_time);
            }
        }
    };

    // Custom lazy loading: only assign image sources to the current slide and nearby slides.
    shouldLoadSlide = (index) => {
        const slideCount = this.props.slideshowImages.length;
        if (slideCount === 0) {
            return false;
        }

        const currentSlide = this.props.currentSlide < 0
            ? 0
            : ((this.props.currentSlide % slideCount) + slideCount) % slideCount;
        for (let offset = -PRELOAD_BEHIND; offset <= PRELOAD_AHEAD; offset++) {
            const preloadIndex = currentSlide + offset;
            if (preloadIndex >= 0 && preloadIndex < slideCount && preloadIndex === index) {
                return true;
            }
        }

        return false;
    };
    
    nextSlide = () => {
        this.goToSlide(this.props.currentSlide + 1);  //increment current slide 
    };

    previousSlide = () => {
        this.goToSlide(this.props.currentSlide - 1);
    };

    goToSlide = (n) => {
        let slides = document.querySelectorAll('.slides .slide');
        this.currentSlide = (n + slides.length) % slides.length;  //set current slide to start over if ready
        this.props.setCurrentSlide(this.currentSlide); //set store current slide to current slide
        this.hideSlideShowSpinner();
    };

    pauseSlideshow = () => {
        let pauseButton = document.getElementById('pause');
        pauseButton.innerHTML = 'Play'
        this.playing = false;
        clearInterval(this.slideInterval);
    };

    //kick off slide show loop
    playSlideshow = (change_image_time) => {
        let pauseButton = document.getElementById('pause');
        pauseButton.innerHTML = 'Pause';
        this.playing = true;
        this.nextSlide(this.props.currentSlide + 1);
        this.slideInterval = setInterval(this.nextSlide, change_image_time);
    };

    hideSlideShowSpinner = () => {
        if (this.currentSlide > -1) {
            this.props.setSlideshowSpinnerIsHidden(true);
        }
        else
            this.props.setSlideshowSpinnerIsHidden(false);
    };

    showSlideShowSpinner = () => {
        this.props.setSlideshowSpinnerIsHidden(false);
    };

    //doing this from NavBar now
    //  hideSlideShowlink = () => {
    //     let slideShowlink = document.getElementById('slideshow-link');
    //     if (slideShowlink) {
    //         slideShowlink.className = 'dimNavLink';
    //     }
    // }; 

    componentDidMount = () => {
        //wire up buttons references
        this.props.saveReferenceToPauseMethod(this.pauseSlideshow);

        let next = document.getElementById('next');

        let previous = document.getElementById('previous');

        let pauseButton = document.getElementById('pause');

        let restartButton = document.getElementById('restart');

        this.commentsHtml = document.getElementById('comments');

        if (next) {
            next.onclick = () => {
                this.pauseSlideshow();
                this.nextSlide();
            };
        }
        if (previous) {
            previous.onclick = () => {
                this.pauseSlideshow();
                this.previousSlide();
            };
        }
        if (pauseButton) {
            pauseButton.onclick = () => {
                if (this.playing) {
                    this.pauseSlideshow();
                } else {
                    this.playSlideshow(2000);
                }
            };
        }
        if (restartButton) {
            restartButton.onclick = () => {
                clearInterval(this.slideInterval);
                this.currentSlide = -1;
                //this.showSlideShowSpinner();
                this.props.setCurrentSlide(this.currentSlide);
                this.playSlideshow(2000);
            };
        }

        this.hideSlideShowSpinner();
        //doing this from NavBar now
        //this.hideSlideShowlink();
    }

    componentWillUnmount = () => {
        clearInterval(this.slideInterval);
        this.props.setSlideshowSpinnerIsHidden(true);
    }

    renderList = () => {
        return <div>{this.props.slideshowImages.map((image, index) => {
            const src = `${image.imagepath}${image.index}a.jpg`;
            const isCurrentSlide = index === this.props.currentSlide;
            const slideImage = this.shouldLoadSlide(index)
                ? <img onLoad={() => this.handleSlideImageLoad(index)} src={src} alt={`${image.description}`} className={isCurrentSlide ? 'responsive' : 'responsive image high-quality crisp-edges'} />
                : null;

            if (isCurrentSlide) {
                return (
                    <li key={image.index} className="imageDescription slide showing" >
                        {slideImage}
                        <div className="slideshowOverlay">{`${image.description} (${image.index})`}</div>
                    </li>
                );
            }
            // You absolutely must return a <li>, even if not showing, because we use the entire list in the  goToSlide = (n) => {} function
            return (
                <li key={image.index} className="imageDescription slide" >
                    {slideImage}
                    <div className="slideshowOverlay">{`${image.description}  (${image.index})`}</div>
                </li>
            );
        })}</div>
    }

    render() {
        return (
            <div>
                <ul className="slides" >
                    <div className={this.props.spinnerIsHidden ? 'dimSpinner loader1' : 'show loader1'} id="loading-spinner"></div>
                    {this.renderList()}
                </ul>
                <span id="comments"></span>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        slideshowImages: state.slideshowImages,
        currentSlide: state.fetchCurrentSlideReducer.currentSlide,
        spinnerIsHidden: state.spinnerVisibility.slideshowSpinnerIsHidden
    };
}
//NOTE action creator(s) included here
export default connect(mapStateToProps, { setImageLoaded: setImageLoaded, setCurrentSlide: setCurrentSlide, setSlideshowSpinnerIsHidden: setSlideshowSpinnerIsHidden, saveReferenceToPauseMethod: saveReferenceToPauseMethod })(SlideShow);




